import * as React from 'react'
import { RecommendationInstance } from '../../../../../../models/Recommendation'
import { Headline } from '../../../../../../shared/components/Headlines'
import { breakpoint, styled } from '../../../../../../shared/styled-components'
import { Utils } from '../../../../../../shared/Utils'

interface IProps {
  recommendation: RecommendationInstance
}

export class JawRecommendation extends React.Component<IProps> {
  render () {
    const { recommendation } = this.props

    const translatedTypes = {
      crown: ['Implantat', 'Implantate'],
      bridge: ['Brücke', 'Brücken']
    }
    let type = translatedTypes[recommendation.recommendationType][0]
    if (recommendation.count !== 1) type = translatedTypes[recommendation.recommendationType][1]

    return (<Container>
      <RecommendationHeadline>{recommendation.count} {type}</RecommendationHeadline>
      <img src={Utils.getAssetPath('/assets/calculator/' + recommendation.recommendationType + '.png')} />
    </Container>)
  }
}

const Container = styled.div`
  flex: 1 1 0;
  margin-right: 50px;
  border-bottom: 1px solid ${props => props.theme.borderColor};
  margin-bottom: 20px;
  &:last-child {
    border: none;
    margin-bottom: 0;
  }
  ${breakpoint('tablet')`
    border-bottom: none;
    border-right: 1px solid ${props => props.theme.borderColor};
    margin-bottom: 0;
  `}
`

const RecommendationHeadline = styled(Headline)`
  margin-bottom: 20px;
  ${breakpoint('tablet')`
    margin-bottom: 50px;  
  `}
`
